import { PublicKey } from "@solana/web3.js";
import { BN } from "@coral-xyz/anchor";
import { currentEpoch, PROGRAM_ID } from "./constants";
export function subDaoEpochInfoKey(subDao, unixTime, programId = PROGRAM_ID) {
    let bU64 = Buffer.alloc(8);
    const epoch = currentEpoch(new BN(unixTime)).toNumber();
    bU64.writeBigUInt64LE(BigInt(epoch));
    return PublicKey.findProgramAddressSync([Buffer.from("sub_dao_epoch_info", "utf-8"), subDao.toBuffer(), bU64], programId);
}
export function daoEpochInfoKey(dao, unixTime, programId = PROGRAM_ID) {
    let bU64 = Buffer.alloc(8);
    const epoch = currentEpoch(new BN(unixTime)).toNumber();
    bU64.writeBigUInt64LE(BigInt(epoch));
    return PublicKey.findProgramAddressSync([Buffer.from("dao_epoch_info", "utf-8"), dao.toBuffer(), bU64], programId);
}
export function daoKey(mint, programId = PROGRAM_ID) {
    return PublicKey.findProgramAddressSync([Buffer.from("dao", "utf-8"), mint.toBuffer()], programId);
}
export function subDaoKey(mint, programId = PROGRAM_ID) {
    return PublicKey.findProgramAddressSync([Buffer.from("sub_dao", "utf-8"), mint.toBuffer()], programId);
}
export function delegatedPositionKey(position, programId = PROGRAM_ID) {
    return PublicKey.findProgramAddressSync([
        Buffer.from("delegated_position", "utf-8"), position.toBuffer()
    ], programId);
}
const CLOCKWORK_PID = new PublicKey("CLoCKyJ6DXBJqqu2VWx9RLbgnwwR6BMHHuyasVmfMzBh");
export function threadKey(authority, threadId, programId = CLOCKWORK_PID) {
    return PublicKey.findProgramAddressSync([
        Buffer.from("thread", "utf8"),
        authority.toBuffer(),
        Buffer.from(threadId, "utf8"),
    ], programId);
}
//# sourceMappingURL=pdas.js.map